export const GET_LOCATIONS_BEGIN = "GET_LOCATIONS_BEGIN"
export const GET_LOCATIONS_ERROR = "GET_LOCATIONS_ERROR"
export const GET_LOCATIONS_SUCCESS = "GET_LOCATIONS_SUCCESS"
export const SELECT_LOCATION = "SELECT_LOCATION"
export const TOGGLE_LOCATION_LIST = "TOGGLE_LOCATION_LIST"
export const EDIT_LOCATION_BEGIN = "EDIT_LOCATION_BEGIN"
export const EDIT_LOCATION_ERROR = "EDIT_LOCATION_ERROR"
export const EDIT_LOCATION_SUCCESS = "EDIT_LOCATION_SUCCESS"